'use client';

import { useEffect, useState } from 'react';
import BannerAd from './BannerAd';
import { useAds } from './AdContext';
import { ADSENSE_SLOT_SIDE } from './adsenseConfig';

type PanelPageAdProps = {
  className?: string;
  slot?: string;
};

export default function PanelPageAd({ className = '', slot }: PanelPageAdProps) {
  const { shouldShowAds } = useAds();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 1200);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  if (!shouldShowAds) {
    return null;
  }

  return (
    <div
      className={[
        'my-4 w-full',
        isMobile ? 'block' : 'md:float-right md:ml-6 md:mb-6 md:w-[300px] md:max-w-[300px]',
        className,
      ].join(' ')}
    >
      <BannerAd
        position="panel"
        slot={slot || ADSENSE_SLOT_SIDE}
      />
    </div>
  );
}